function I18N_Strings(i18n)
{
    i18n.loadTranslations('hu', {
        
        "app.name": "Katalógus",

        "head.lang_switch": "English",
        
        "menu.publications": "Kiadványok",
        "menu.first_releases": "Gyorstájékoztatók",
        "menu.stadat": "Táblák (STADAT)",
        "menu.dissem_db": "Tájékoztatási adatbázis",
        
        "footer.ksh_home": "KSH Nyitólap",
        "footer.contacts": "Elérhetőségek",
        "footer.copyright": "Copyright",
        
        "sidebar.release_date_notice": "Kiadványaink várható megjelenését tájékoztató jelleggel közöljük, a változtatás jogát fenntartjuk.",
        "sidebar.update_date_notice": "Adataink várható frissítését tájékoztató jelleggel közöljük, a változtatás jogát fenntartjuk.",
        
        "publications.sidebar_download_title": "Kiadványok naptára (xls)",
        "publications.sidebar_download_url": "kiadvanyok_megjelenesi_naptara.xls",
        "publications.jump_to_publications": "Megtekintés a KSH Kiadványtárában",
        
        "first_releases.sidebar_order_title": "Gyorstájékoztató megrendelése",
        "first_releases.sidebar_order_url": "http://www.ksh.hu/gyorstajekoztato_megrendelese",
        "first_releases.sidebar_download_title": "Gyorstájékoztatók naptára (xls)",
        "first_releases.sidebar_download_url": "http://www.ksh.hu/docs/hun/xftp/2018_tajeknaptar.xls",
        "first_releases.jump_to_document": "Gyorstájékoztató megtekintése",
        
        "stadat.sidebar_download_title": "",
        "stadat.sidebar_download_url": "",
        "stadat.jump_to_table": "STADAT tábla megtekintése",
        
        "dissem_db.sidebar_download_title": "",
        "dissem_db.sidebar_download_url": "",
        "dissem_db.jump_to_datagroup": "Adatkör megnyitása",
        
        "catalog.topics_title": "Témakörök",
        "catalog.switch_to_calendar": "Naptár nézet",
        "catalog.sort_by": "Rendezés: ",
        "catalog.category": "Kategória: ",
        "catalog.all_topics": "Minden témakör",
        "catalog.all_category": "Minden kategória",
        "catalog.tag_title": "Cimke: %tag%",
        
        "catalog.no_publications_to_show": "Olyan szűrési feltételeket adott meg, melynek egy kiadvány sem felel meg!",
        "catalog.no_first_releases_to_show": "Olyan szűrési feltételeket adott meg, melynek egy gyorstájékoztató sem felel meg!",
        "catalog.no_stadat_table_to_show": "Olyan szűrési feltételeket adott meg, melynek egy STADAT tábla sem felel meg!",
        "catalog.no_data_to_show": "Olyan szűrési feltételeket adott meg, melynek egy adatkör sem felel meg!",
        
        "catalog.sort_by_tableno_asc": "Táblaszám szerint (1-9)",
        "catalog.sort_by_tableno_desc": "Táblaszám szerint (9-1)",
        "catalog.sort_by_name_asc": "Cím szerint (A-Z)",
        "catalog.sort_by_name_desc": "Cím szerint (Z-A)",
        "catalog.sort_by_date_asc": "Dátum szerint (01-12)",
        "catalog.sort_by_date_desc": "Dátum szerint (12-01)",
        "catalog.sort_by_nextupdate_asc": "Következő frissítés szerint (01-12)",
        "catalog.sort_by_nextupdate_desc": "Következő frissítés szerint (12-01)",
        
        "catalog.action_open_all": "Mind szétnyit",
        "catalog.action_close_all": "Mind összezár",
        
        "catalog.filter_released": "Csak a megjelentek",
        "catalog.filter_free": "Csak az ingyenesek",
        
        "catalog.loading_data": "Adatok betöltése...",
        "catalog.loading_content": "Adatok betöltése...",
        
        "calendar.title": "Közzétételi naptár",
        "calendar.switch_to_catalog": "Lista nézet",
        "calendar.other_pubs_in_month": "A hónapban várható további kiadványaink",
        "calendar.no_items_to_show": "Ebben a hónapban nincsenek megjeleníthető elemek!",
        "calendar.weekno": "Hét",
        "calendar.day_mon": "H",
        "calendar.day_tue": "K",
        "calendar.day_wed": "Sze",
        "calendar.day_thu": "Cs",
        "calendar.day_fri": "P",
        "calendar.day_sat": "Szo",
        "calendar.day_sun": "V",
        
        "item.label_topics": "Témakör:",
        "item.label_category": "Kategória:",
        "item.label_language": "Nyelv:",
        "item.label_tags": "Címkék:",
        "item.label_price": "Ára: ",
        "item.label_release_date": "{-1} Megjelent:|Várható megjelenés:",
        "item.label_last_update_date": "Utoljára frissítve:",
        "item.label_next_update": "Következő frissítés:",
        "item.label_further_updates": "További frissítések:",
        
        "item.status": "{-1} Megjelent|{0} Várható megjelenés ebben a hónapban|{1} Várható megjelenés a következő hónapban|[2,+Inf] Várható megjelenés %month% hónap múlva",
        "item.status_modified": "[-Inf,-1] Megjelent|{0} Várható megjelenés ebben a hónapban (módosított)|{1} Várható megjelenés a következő hónapban (módosított)|[2,+Inf] Várható megjelenés %month% hónap múlva (módosított)",
        
        "item.upd_status": "{-1} Frissült|{0} Várható frissítés ebben a hónapban|{1} Várható frissítés a következő hónapban|[2,+Inf] Várható frissítés %month% hónap múlva",
        "item.upd_status_modified": "[-Inf,-1] Frissült|{0} Várható frissítés ebben a hónapban (módosított)|{1} Várható frissítés a következő hónapban (módosított)|[2,+Inf] Várható frissítés %month% hónap múlva (módosított)",
        
        "item.price_hu": "ingyenes|%price% Ft",
        "item.price_en": "ingyenes|%price% EUR",
        
        "item.dissem_db_dataset_unavailable": "Adatellenőrzés miatt az adatkör nem érhető el.",
        
        "legend.long_series": "Hosszú idősor",
        "legend.annual_series": "Idősoros éves",
        "legend.infra_annual_series": "Évközi",
        "legend.tab.annual_series": "Éves adatok",
        "legend.tab.infra_annual_series": "Évközi adatok",
        
        "error.title": "Hiba",
        "error.404": "A kért lap nem található, ellenőrizze a beírt címet!",
        "error.no_such_item": "Nincs ilyen elem.",
        "error.unexpected_error": "Nem várt hiba történt!",
        
        "hello.world": "Helló Világ!"
    });
    
    i18n.loadTranslations('en', {
        
        "app.name": "Catalog",
        
        "head.lang_switch": "magyar",
        
        "menu.publications": "Publications",
        "menu.first_releases": "First releases",
        "menu.stadat": "Tables (STADAT)",
        "menu.dissem_db": "Dissemination database",
        
        "footer.ksh_home": "HCSO Homepage",
        "footer.contacts": "Contact us",
        "footer.copyright": "Copyright",
        
        "sidebar.release_date_notice": "The expected release dates of our publications are only for information, and they are subject to change without notice.",
        "sidebar.update_date_notice": "The expected update times of our tables are only for information, and they are subject to change without notice.",
        "sidebar.eur_price_conversion_notice": "The EUR prices of the publications are given for information purposes. In case you place an order, invoicing will be made at the mean exchange rate of the National Bank of Hungary on the day of order.",
        
        "publications.sidebar_download_title": "Publications calendar (xls)",
        "publications.sidebar_download_url": "publications_release_calendar.xls",
        "publications.jump_to_publications": "View in the HCSO Publication repertory",
        
        "first_releases.sidebar_order_title": "Ordering First releases",
        "first_releases.sidebar_order_url": "http://www.ksh.hu/ordering_first_releases",
        "first_releases.sidebar_download_title": "First releases calendar (xls)",
        "first_releases.sidebar_download_url": "http://www.ksh.hu/docs/hun/xftp/2018_tajeknaptar.xls",
        "first_releases.jump_to_document": "View First release",
        
        "stadat.sidebar_download_title": "",
        "stadat.sidebar_download_url": "",
        "stadat.jump_to_table": "View STADAT table",
        
        "dissem_db.sidebar_download_title": "",
        "dissem_db.sidebar_download_url": "",
        "dissem_db.jump_to_datagroup": "View data set",
        
        "catalog.topics_title": "Topics",
        "catalog.switch_to_calendar": "Calendar view",
        "catalog.sort_by": "Sort: ",
        "catalog.category": "Category: ",
        "catalog.all_topics": "All topics",
        "catalog.all_category": "All category",
        "catalog.tag_title": "Tag: %tag%",
        
        "catalog.no_publications_to_show": "You specified such filter criteria, which did not match with any publication!",
        "catalog.no_first_releases_to_show": "You specified such filter criteria, which did not match with any first release!",
        "catalog.no_stadat_table_to_show": "You specified such filter criteria, which did not match with any STADAT table!",
        "catalog.no_data_to_show": "You specified such filter criteria, which did not match with any data set!",
        
        "catalog.sort_by_tableno_asc": "Table number (1-9)",
        "catalog.sort_by_tableno_desc": "Table number (9-1)",
        "catalog.sort_by_name_asc": "Table title (A-Z)",
        "catalog.sort_by_name_desc": "Table title (Z-A)",
        "catalog.sort_by_date_asc": "Date (01-12)",
        "catalog.sort_by_date_desc": "Date (12-01)",
        "catalog.sort_by_nextupdate_asc": "Next update date (01-12)",
        "catalog.sort_by_nextupdate_desc": "Next update date (12-01)",
        
        "catalog.action_open_all": "Expand all",
        "catalog.action_close_all": "Collapse all",
        
        "catalog.filter_released": "Released only",
        "catalog.filter_free": "Free only",
        
        "catalog.loading_data": "Loading data...",
        "catalog.loading_content": "Loading content...",
        
        "calendar.title": "Release calendar",
        "calendar.switch_to_catalog": "List view",
        "calendar.other_pubs_in_month": "Our other publications expected in this month",
        "calendar.no_items_to_show": "There is no items to show!",
        "calendar.weekno": "Week",
        "calendar.day_mon": "Mon",
        "calendar.day_tue": "Tue",
        "calendar.day_wed": "Wed",
        "calendar.day_thu": "Thu",
        "calendar.day_fri": "Fri",
        "calendar.day_sat": "Sat",
        "calendar.day_sun": "Sun",
        
        "item.label_topics": "Topic:",
        "item.label_category": "Category:",
        "item.label_language": "Language:",
        "item.label_tags": "Tags:",
        "item.label_price": "Price: ",
        "item.label_release_date": "{-1} Released:|Expected release:",
        "item.label_last_update_date": "Last updated:",
        "item.label_next_update": "Next update:",
        "item.label_further_updates": "Future updates:",
        
        "item.status": "{-1} Released|{0} Expected release this month|{1} Expected release next month|[2,+Inf] Expected release in %month% month",
        "item.status_modified": "[-Inf,-1] Released|{0} Expected release this month (modified)|{1} Expected release next month (modified)|[2,+Inf] Expected release in %month% month (modified)",
        
        "item.upd_status": "{-1} Updated|{0} Expected update this month|{1} Expected update next month|[2,+Inf] Expected update in %month% month",
        "item.upd_status_modified": "[-Inf,-1] Updated|{0} Expected update this month (modified)|{1} Expected update next month (modified)|[2,+Inf] Expected update in %month% month (modified)",
        
        "item.price_hu": "free|%price% Ft",
        "item.price_en": "free|%price% EUR",
        
        "item.dissem_db_dataset_unavailable": "Currently this dataset is unavailable due to data validation.",
        
        "legend.long_series": "Long time series",
        "legend.annual_series": "Annual series",
        "legend.infra_annual_series": "Infra-annual series",
        "legend.tab.annual_series": "Annual data",
        "legend.tab.infra_annual_series": "Infra-annual data",
        
        "error.title": "Error",
        "error.404": "The requested page does not exists, please check the URL!",
        "error.no_such_item": "No such item or category.",
        "error.unexpected_error": "Unexpected error!",
                
        "hello.world": "Hello World!"
    });
}